import React, { lazy, Suspense } from 'react';
import { Switch } from 'react-router-dom';
import { ROUTES } from '../constants';
import GuestRoute from './GuestRoute';
import HomePage from '../pages/HomePage';
import NotFoundPage from '../pages/NotFoundPage';

const GameDetailPage = lazy(() => import('src/pages/GameDetailPage'));

function LazyGameDetail(props) {
  return (
    <Suspense fallback={<div />}>
      <GameDetailPage {...props} />
    </Suspense>
  );
}

function Routes() {
  return (
    <Switch>
      <GuestRoute
        exact
        path={ROUTES.ROOT_PATH}
        component={HomePage}
      />
      <GuestRoute
        path="/game/:code"
        component={LazyGameDetail}
      />
      <GuestRoute
        path="*"
        component={NotFoundPage}
      />
    </Switch>
  );
}

export default Routes;
